
(function() {

  /******************************
   * Helper: cm-Werte parsen
   ******************************/
  function parseNumberFromCm(str) {
    return parseFloat(
      String(str || "").replace("cm", "").replace(",", ".").trim()
    );
  }

  function parseSizeFromOption(value) {
    if (!value) return null;
    const parts = value.split("x");
    if (parts.length !== 2) return null;

    const w = parseNumberFromCm(parts[0]);
    const h = parseNumberFromCm(parts[1]);

    if (isNaN(w) || isNaN(h)) return null;
    return { width: w, height: h };
  }

  function getTargetSize() {
    const wInput = document.getElementById("target-width-cm");
    const hInput = document.getElementById("target-height-cm");
    if (!wInput || !hInput) return null;

    const w = parseNumberFromCm(wInput.value);
    const h = parseNumberFromCm(hInput.value);

    if (isNaN(w) || isNaN(h) || w <= 0 || h <= 0) return null;

    return { width: w, height: h };
  }

  /******************************
   * Beste Variante wählen
   ******************************/
  function selectBestVariant() {
    const select = document.querySelector(
      '.product-variant-container[data-js-product-variant-container="select"]'
    );
    if (!select) return;

    const target = getTargetSize();
    if (!target) return;

    const options = Array.from(select.options);
    if (!options.length) return;

    const targetArea = target.width * target.height;

    let bestFit = null;
    let bestFitArea = null;

    let closest = null;
    let closestDiff = null;

    options.forEach(opt => {
      const size = parseSizeFromOption(opt.value);
      if (!size) return;

      const area = size.width * size.height;

      // 1) Best Fit: kleinste Variante, die gross genug ist
      if (size.width >= target.width && size.height >= target.height) {
        if (bestFit == null || area < bestFitArea) {
          bestFit = opt;
          bestFitArea = area;
        }
      }

      // 2) Fallback: Fläche am nächsten
      const diff = Math.abs(area - targetArea);
      if (closest == null || diff < closestDiff) {
        closest = opt;
        closestDiff = diff;
      }
    });

    const chosen = bestFit || closest;
    if (!chosen) return;

    if (select.value !== chosen.value) {
      select.value = chosen.value;
      select.dispatchEvent(new Event("change", { bubbles: true }));
      // console.log("Variant auto-selected:", chosen.value);
    }
  }

  /******************************
   * Input-Änderungen überwachen
   ******************************/
  function setupWatchers() {
    const wInput = document.getElementById("target-width-cm");
    const hInput = document.getElementById("target-height-cm");
    if (!wInput || !hInput) return;

    let lastW = wInput.value;
    let lastH = hInput.value;

    // Events vom User
    ["input", "change", "blur"].forEach(evt => {
      wInput.addEventListener(evt, selectBestVariant);
      hInput.addEventListener(evt, selectBestVariant);
    });

    // Polling für programmatische Änderungen
    setInterval(function() {
      const curW = wInput.value;
      const curH = hInput.value;

      if (curW !== lastW || curH !== lastH) {
        lastW = curW;
        lastH = curH;
        selectBestVariant();
      }
    }, 200); // alle 200ms checken – performant genug, aber reaktiv
  }

  /******************************
   * Init
   ******************************/
  function init() {
    setupWatchers();
    // initial einmal auswählen
    selectBestVariant();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    // Falls Script nach DOMContentLoaded geladen wird
    init();
  }

})();

